import { defineComponent as _defineComponent } from 'vue'
import { mdiFacebook, mdiPinterest, mdiTwitter } from "@mdi/js";
import { type PropType, computed, toRefs, useRoute } from "@nuxtjs/composition-api";

import { useAmplitude, useConfig } from "@/composables";
import { getLinks as getSocialLinks } from "@/utils/services/SocialService";

/**
 * Function to return typescript safe event names based on a share target.
 * This enables deeper type matching of the event name, and expected event properties.
 */
interface ShareButton {
  // to ensure unexpected share targets cannot be used
  id: ShareTarget;
  // to allow proper case of the share name
  name: ShareTarget;
  // icon to appear on the button
  icon: string;
  // compiled location of the share target
  href?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareLinks',
  props: {
  imageUrl: { type: String, required: true },
  shareUrl: { type: String as PropType<string | undefined>, default: undefined },
  caption: { type: String as PropType<string | null | undefined>, default: undefined },
  isRunway: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;

function getShareEvent(target: ShareTarget) {
  switch (target) {
    case "facebook":
      return "/share/facebook";
    case "twitter":
      return "/share/twitter";
    case "pinterest":
      return "/share/pinterest";
    case "link":
      return "/share/link";
  }
}



const { imageUrl, shareUrl, caption, isRunway } = toRefs(props);

const amplitude = useAmplitude();
const route = useRoute();
const config = useConfig();

const socialLinks = computed(() => {
  return getSocialLinks({
    shareUrl: shareUrl.value ?? `https://${config.ltkSite}${route.value.fullPath}`,
    imageUrl: imageUrl.value,
    caption: caption.value,
  });
});

const shareBtns = computed((): ShareButton[] => {
  return [
    {
      id: "facebook",
      name: "facebook",
      icon: mdiFacebook,
      href: socialLinks.value.facebook,
    },
    {
      id: "pinterest",
      name: "pinterest",
      icon: mdiPinterest,
      href: socialLinks.value.pinterest,
    },
    {
      id: "twitter",
      name: "twitter",
      icon: mdiTwitter,
      href: socialLinks.value.twitter,
    },
  ];
});

function onShareClick(target: ShareTarget, url: string, index: number) {
  const event = getShareEvent(target);
  const count = shareBtns.value.length;
  amplitude?.sendEvent(event, { url, count, index });
}

return { __sfc: true,getShareEvent, props, imageUrl, shareUrl, caption, isRunway, amplitude, route, config, socialLinks, shareBtns, onShareClick }
}

})